export class SchemaRegistrySchemaByIdRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "schemaRegistry",
            "baseName": "schemaRegistry",
            "type": "SchemaRegistryConfig",
            "format": ""
        },
        {
            "name": "schemaId",
            "baseName": "schemaId",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistrySchemaByIdRequest.attributeTypeMap;
    }
    constructor() {
    }
}
